// @ts-nocheck
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(dateRangeStyles, {
    datePickersWrapper: {
        css: css`
            display: flex;
            ${breakpoint("xs", "down")} {
                flex-wrap: wrap;
            }
        `,
    },
    fromDate: {
        cssOverrides: {
            formField: css`
                ${breakpoint("sm", "up")} {
                    padding-right: ${pxToRem(10)};
                }
            `,
        },
    },
    toDate: {
        cssOverrides: {
            formField: css`
                padding-left: ${pxToRem(10)};

                ${breakpoint("xs", "down")} {
                    padding-top: ${pxToRem(10)};
                    padding-left: 0;
                }
            `,
        },
        labelProps: {
            color: "common.background",
        },
    },
});
